import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VerifyDestination from './VerifyDestination';
import VerifyResend from './VerifyResend';
import ErrorHandler from '../errorHandler/errorHandler';
import axios from 'axios';
import { setupOtpBeforeUnload, teardownOtpBeforeUnload } from './otpBeforeUnload';

const propTypes = {
    deliveryMethod: PropTypes.string.isRequired,
    editURL: PropTypes.string.isRequired,
    showEdit: PropTypes.bool,
    hideVerifyButton: PropTypes.bool,
    destinationText: PropTypes.string,
    errorMessage: PropTypes.string,
    helpUrl: PropTypes.string,
    resendUrl: PropTypes.string
};

class VerifyOTPContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            inputValue: '',
            error: props.errorMessage !== undefined ? this.props.errorMessage : ''
        };

        if (props.deliveryMethod === 'email') {
            this.state.message = 'A verification code has been sent to:';
        } else {
            var typeString = this.props.deliveryMethod === 'sms' ? 'text message' : 'voice call';
            this.state.message = 'A ' + typeString + ' with a verification code has been sent to:';
        }

        if (!props.hideVerifyButton) {
            this.verifyButton = (
                <div className="asc-btn-group">
                    <button className="asc-btn asc-btn--tertiary asc-btn--small" type="submit">
                        Verify
                    </button>
                </div>
            );
        }

        this.state.showOptions =
            this.props.deliveryMethod === 'sms' || this.props.deliveryMethod === 'voice';
        this.resendOTP = this.resendOTP.bind(this);
        this.handleInput = this.handleInput.bind(this);
    }

    handleInput(event) {
        this.setState({ inputValue: event.target.value });
    }

    componentDidMount() {
        setupOtpBeforeUnload(this.props.deliveryMethod, { inputName: 'securitycode' });
    }

    componentWillUnmount() {
        teardownOtpBeforeUnload();
    }

    resendOTP(event) {
        event.preventDefault();
        this.setState({
            message: 'Sending another verification code to:',
            error: ''
        });
        var params =
            this.props.deliveryMethod === 'email'
                ? this.props.destinationText
                : {
                      PhoneNumber: this.props.destinationText,
                      DeliveryMethod: this.props.deliveryMethod
                  };

        axios
            .post(this.props.resendUrl, params)
            .then(response => {
                if (response.data.success !== null && response.data.success) {
                    var typeString = this.props.deliveryMethod === 'email' ? 'email' : 'phone';
                    this.setState({
                        message:
                            'Another verification code has been sent to your ' + typeString + '.'
                    });
                } else if (response.data.maxReached !== null && response.data.maxReached) {
                    // If baseURI is implemented, use correct relative path. For IE, special case.
                    window.location.href = document.baseURI
                        ? this.props.helpUrl
                        : '.' + this.props.helpUrl;
                } else {
                    this.setState({
                        message: '',
                        error: 'Resending the verification code was not successful. Please try again.'
                    });
                }
            })
            .catch(function (error) {
                new ErrorHandler().logError('Failed to resend email verification code. ' + error);
            });
    }
    render() {
        return (
            <div>
                <p>{this.state.message}</p>
                <VerifyDestination
                    destinationText={this.props.destinationText}
                    editURL={this.props.editURL}
                    showEdit={this.props.showEdit}
                />

                <VerifyResend
                    handleResend={this.resendOTP}
                    showOptions={this.state.showOptions}
                    resendUrl={this.props.editURL}
                />
                <div className="asc-form-group asc-form-group--small mfa-form-group--nobottommargin">
                    <label className="asc-form-label" htmlFor="securitycode">
                        Verification Code
                    </label>
                </div>
                <p>Please allow a couple minutes for delivery.</p>
                <div className="asc-form-group--small text--left">
                    <input
                        id="securitycode"
                        className="asc-form-input asc-form-input--small"
                        type="text"
                        name="securitycode"
                        value={this.state.inputValue}
                        onChange={this.handleInput}
                        pattern="\d*"
                        required
                    />
                </div>

                {typeof this.state.error !== 'undefined' && (
                    <div className="is-warning">
                        <p className="asc-form-help">{this.state.error}</p>
                    </div>
                )}

                {this.verifyButton}
            </div>
        );
    }
}

VerifyOTPContainer.propTypes = propTypes;
export default VerifyOTPContainer;
